import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { AppointmentInfo } from '../../ui-module/appointment-info.js';
import type { AppointmentInfo as AppointmentInfoData } from '../../token-module/appointment-info.interface.js';

const ICON_POP = {
  initial: { scale: 0.6, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  transition: { type: 'spring' as const, stiffness: 300, damping: 18 },
};

interface SuccessScreenProps {
  readonly appointmentInfo?: AppointmentInfoData;
}

/**
 * Success-Screen: zentrierte Termininformation, 64-px-Kreis mit Lovable-
 * Check-Icon, Headline und Body. Endzustand — kein CTA.
 */
export function SuccessScreen(props: SuccessScreenProps = {}): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-8">
      <AppointmentInfo
        headlineKey="success.headline"
        {...(props.appointmentInfo ? { info: props.appointmentInfo } : {})}
      />
      <motion.div
        className="flex h-16 w-16 items-center justify-center rounded-full bg-success/15"
        initial={ICON_POP.initial}
        animate={ICON_POP.animate}
        transition={ICON_POP.transition}
        aria-label={t('success.iconAlt')}
        role="img"
      >
        <Check className="h-8 w-8 text-success" strokeWidth={3} />
      </motion.div>
      <p
        role="status"
        aria-live="polite"
        className="max-w-xs text-center text-sm leading-relaxed text-muted-foreground"
      >
        {t('success.message')}
      </p>
    </div>
  );
}
